/* Cocoony serum duo offer only. Prices/discount eligibility are enforced by Shopify. */
(() => {
  'use strict';
  const configNode = document.getElementById('co-serum-gifts-cart-config');
  if (!configNode || window.coSerumGiftsCart) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.enabled) return;
  const parents = new Set(config.parents.map(String));
  const gifts = config.gifts.map(String);
  const marker = '_co_offer_gift';
  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify?.routes?.root || '/');
  let serial = Promise.resolve(), knownCart = config.cart, checkoutPass = false;
  let hasOffer = Boolean(config.hasOffer), pending = 0;
  const isParent = item => parents.has(String(item.variant_id || item.id));
  const isGift = item => item.properties?.[marker] === config.product;
  const cartState = cart => JSON.stringify(cart.items.map(i => [i.key, i.quantity, i.final_line_price]));
  const giftLine = (id, quantity) => ({ id: Number(id), quantity, properties: { [marker]: config.product } });

  function enqueue(task) {
    const job = serial.then(task);
    serial = job.catch(() => {});
    return job;
  }
  function remember(cart) {
    knownCart = cart;
    hasOffer = cart.items.some(isParent);
    document.documentElement.toggleAttribute('data-co-serum-gifts-cart', hasOffer);
    return cart;
  }
  async function api(path, payload) {
    const response = await nativeFetch(root + path, payload === undefined ? {} : {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Please wait a moment and try again. Your order has not been placed.');
    return response.json();
  }
  function plan(cart) {
    const quantity = cart.items.filter(i => isParent(i) && !i.has_components).reduce((n, i) => n + i.quantity, 0);
    const updates = {}, add = [];
    // Migrate earlier marked gift lines only. Purchased upsells are untouched.
    for (const line of cart.items) {
      if (isGift(line) && !gifts.includes(String(line.variant_id))) updates[line.key] = 0;
    }
    for (const id of gifts) {
      const lines = cart.items.filter(i => isGift(i) && String(i.variant_id) === id);
      if (!lines.length && quantity) add.push(giftLine(id, quantity));
      lines.forEach((line, index) => {
        const wanted = index === 0 ? quantity : 0;
        if (line.quantity !== wanted) updates[line.key] = wanted;
      });
    }
    return { quantity, updates, add };
  }
  async function reconcile(cart) {
    const action = plan(cart);
    if (Object.keys(action.updates).length) cart = await api('cart/update.js', { updates: action.updates });
    if (action.add.length) {
      await api('cart/add.js', { items: action.add });
      cart = await api('cart.js');
    }
    // Shopify's pooled BXGY rule prioritizes newer eligible cart lines. Keep
    // separately purchased accessories intact while restoring the gift lines.
    if (action.quantity && cart.items.some(i => isGift(i) && i.final_line_price !== 0)
        && cart.items.some(i => !isGift(i) && gifts.includes(String(i.variant_id)))) {
      const updates = Object.fromEntries(cart.items.filter(isGift).map(i => [i.key, 0]));
      await api('cart/update.js', { updates });
      await api('cart/add.js', { items: gifts.map(id => giftLine(id, action.quantity)) });
      cart = await api('cart.js');
    }
    return remember(cart);
  }
  function assertGifts(cart) {
    const desired = plan(cart).quantity;
    if (!desired) return;
    for (const id of gifts) {
      const lines = cart.items.filter(i => isGift(i) && String(i.variant_id) === id);
      if (lines.reduce((n,i) => n+i.quantity,0) !== desired || lines.some(i => i.final_line_price !== 0)) {
        throw new Error('Your free gifts could not be confirmed. Please remove any other discount code and try again, or contact us before paying.');
      }
    }
  }
  function message(text) {
    let target = document.getElementById('co-serum-gifts-cart-error');
    if (!target) {
      target = document.createElement('div'); target.id = 'co-serum-gifts-cart-error';
      target.setAttribute('role', 'alert');
      target.style.cssText = 'position:fixed;bottom:20px;left:5%;right:5%;padding:14px;background:#fff1f3;color:#8d1233;border:1px solid #d10052;z-index:999999;border-radius:8px;font:14px/1.4 sans-serif';
      document.body.append(target);
    }
    target.textContent = text;
  }
  function parseBody(body) {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { body = new URLSearchParams(body); }
    }
    if (!(body instanceof FormData) && !(body instanceof URLSearchParams)) return null;
    const result = {}, items = [];
    for (const [key, value] of body.entries()) {
      let m = key.match(/^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
      if (m) {
        const row = items[Number(m[1])] ||= {};
        if (m[3]) (row[m[2]] ||= {})[m[3]] = value; else row[m[2]] = value;
      } else if ((m = key.match(/^properties\[([^\]]+)\]$/))) {
        (result.properties ||= {})[m[1]] = value;
      } else if ((m = key.match(/^updates\[([^\]]+)\]$/))) {
        (result.updates ||= {})[m[1]] = value;
      } else { result[key] = value; }
    }
    if (items.length) result.items = items.filter(Boolean);
    return result;
  }
  async function refreshSections(data) {
    if (!data.sections) return null;
    const names = Array.isArray(data.sections) ? data.sections.join(',') : data.sections;
    const url = new URL(data.sections_url || location.pathname, location.origin);
    url.searchParams.set('sections', names);
    const response = await nativeFetch(url);
    if (!response.ok) throw new Error('The cart could not be refreshed. Please reload this page.');
    return response.json();
  }
  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin);
    const method = (init?.method || input?.method || 'GET').toUpperCase();
    const endpoint = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/)?.[1];
    if (url.origin !== location.origin || method !== 'POST' || !endpoint || !init?.body) return nativeFetch(input, init);
    const data = parseBody(init.body);
    if (!data) return nativeFetch(input, init);
    const requested = data.items || (data.id ? [{ id: data.id, quantity: data.quantity || 1, properties: data.properties, selling_plan: data.selling_plan }] : []);
    const offerAddition = endpoint === 'add' && requested.some(isParent);
    if (!offerAddition && !hasOffer && !knownCart?.items?.some(isGift)) return nativeFetch(input, init);
    return enqueue(async () => {
      pending++;
      try {
        let outgoing = data;
        if (offerAddition) {
          const amount = requested.filter(isParent).reduce((n,i)=>n+Number(i.quantity || 1),0);
          outgoing = { ...data, items: [...requested, ...gifts.map(id=>giftLine(id,amount))] };
          delete outgoing.id; delete outgoing.quantity; delete outgoing.properties; delete outgoing.selling_plan;
        }
        const headers = new Headers(init.headers || {});
        headers.set('Content-Type','application/json'); headers.set('Accept','application/json');
        const response = await nativeFetch(input, { ...init, headers, body: JSON.stringify(outgoing) });
        if (!response.ok) return response;
        const result = await response.clone().json();
        let cart = endpoint === 'add' ? await api('cart.js') : result;
        const before = cartState(cart);
        cart = await reconcile(cart);
        // Theme renders the final gift quantities, never an intermediate cart.
        let output = endpoint === 'add' ? result : { ...cart, sections: result.sections };
        if (before !== cartState(cart)) output.sections = await refreshSections(data) || output.sections;
        if (endpoint === 'add' && !data.items && result.items) {
          output = { ...result.items.find(isParent), ...output };
        }
        if (hasOffer) { try { assertGifts(cart); } catch (error) { message(error.message); } }
        return new Response(JSON.stringify(output), { status: response.status, statusText: response.statusText, headers: response.headers });
      } catch (error) { message(error.message); throw error; }
      finally { pending--; }
    });
  };
  async function checkout(callback) {
    try {
      await enqueue(async () => { const cart = await reconcile(await api('cart.js')); assertGifts(cart); });
      checkoutPass = true;
      try { callback(); } finally { checkoutPass = false; }
    } catch (error) { message(error.message); }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('button[name="checkout"],input[name="checkout"],a[href^="/checkout"],button[onclick*="checkoutLoad"]');
    if (!control || checkoutPass || (!hasOffer && !pending && !knownCart?.items?.some(isGift))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    checkout(() => control.click());
  }, true);
  document.addEventListener('submit', event => {
    if (checkoutPass || event.submitter?.name !== 'checkout' || (!hasOffer && !pending)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    checkout(() => event.target.requestSubmit(event.submitter));
  }, true);
  // A returning customer may open an older cart directly. Reconcile it on load.
  if (hasOffer || knownCart?.items?.some(isGift)) {
    enqueue(async () => {
      const old = knownCart;
      const cart = await reconcile(await api('cart.js'));
      if (cartState(old) !== cartState(cart)) location.reload();
    }).catch(error => message(error.message));
  }
  document.documentElement.toggleAttribute('data-co-serum-gifts-cart', hasOffer);
  window.coSerumGiftsCart = { plan, parseBody, assertGifts, getCart: () => knownCart };
})();
